import isLoadingWrapper from '../../actions/load/is-loading-wrapper';
import loadCourse from '../../api/courses/load-course';

const getGuidebook = (state, prevRootId, rootId) => dispatch =>
  prevRootId !== rootId
    ? dispatch(isLoadingWrapper(dispatch(loadCourse(rootId))))
    : Promise.resolve(state.guidebook);

export default getGuidebook;
